import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry } from './logEntry';

type ConversationTranscriptionEndedProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_TRANSCRIPTION_ENDED'>;
};

export const ConversationTranscriptionEnded = ({
  entry,
}: ConversationTranscriptionEndedProps): JSX.Element => {
  const text = entry.is_successful ? (
    <>Conversation transcription ended successfully</>
  ) : (
    <>Error while transcribing the conversation</>
  );
  return (
    <LogEntry entry={entry} text={text} secondaryText={entry.failure_reason} />
  );
};
